import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from '@mui/material';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import BaseModal from '@/components/modals/BaseModal';
import { close } from '@/store/uiSlice.ts';
import { useI18nContext } from '@/i18n/i18n-react';

const AgendaModal = () => {
    const dispatch = useAppDispatch();
    const open = useAppSelector((state) => state.ui.open.agenda);
    const onClose = () => dispatch(close('agenda'));
    const { LL } = useI18nContext();

    const agenda = useAppSelector((state) => state.modal.agenda);

    return (
        <BaseModal open={open} onClose={onClose} title={LL.agendaModal.title()}>
            <TableContainer component={Paper} variant="outlined">
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>{LL.agendaModal.time()}</TableCell>
                            <TableCell>{LL.agendaModal.topic()}</TableCell>
                            <TableCell>{LL.agendaModal.responsible()}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {agenda.map((item, idx) => {
                            const date = new Date(item.time);
                            const timeStr =
                                date?.toLocaleTimeString(undefined, {
                                    hour: '2-digit',
                                    minute: '2-digit',
                                }) ?? '';
                            return (
                                <TableRow key={idx}>
                                    <TableCell>{timeStr}</TableCell>
                                    <TableCell sx={{ wordBreak: 'break-word' }}>
                                        {item.title}
                                    </TableCell>
                                    <TableCell sx={{ wordBreak: 'break-word' }}>
                                        {item.responsible}
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </BaseModal>
    );
};

export default AgendaModal;
